import { createAction, props } from '@ngrx/store';

export const actionPrefix = '[routerCustom]';

export const setInitUrl = createAction(actionPrefix + ' SetInitUrl', props<{ url: string }>());
